

import React from 'react';
import { css } from '@emotion/css';
import cactusEmptyStateIllustration from '@/assets/cactus-empty-state.svg';
import colors from '@/theme/colors';
import { BodyMediumMidEmphasis } from '@/design-system';

export const NoFlyersAvailableSectionEmptyState: React.FC = () => (
  <div className={styles.container}>
    <img
      src={cactusEmptyStateIllustration}
      width="37.9px"
      height="37.9px"
      alt="cactus empty state"
      data-testid="illustration"
    />
    <BodyMediumMidEmphasis
      color={colors.slate}
      data-testid="title"
    >
      No flyers currently available for this section
    </BodyMediumMidEmphasis>
  </div>
);

  const styles = {
    container: css`
      margin: 32px 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
    `
  }
